import { useBookmarked } from "features/article/fabric";
import { usePartners } from "features/partners/fabric";
import { useStart } from "features/start/fabric";

import { useFeatured, useTop, useLastSeen } from "areas/home/fabric";
import Articles from "areas/home/ui/Articles";
import Faq from "areas/home/ui/Faq";
import Features from "areas/home/ui/Features";
import Layout from "areas/home/ui/Layout";
import Partners from "areas/home/ui/Partners";
import Subscribe from "areas/home/ui/Subscribe";


Home.In = () => {
	const top = useTop();
	const lastSeen = useLastSeen();
	const bookmarked = useBookmarked();

	return (
		<>
			<Articles title="Daily Top Articles" subtitle="Most Popular Articles Unlocked By Subly Users Today" articles={top.day.data} loading={top.day.isLoading} ordered />
			<Articles title="Weekly Top Articles" subtitle="Most Popular Articles Unlocked By Subly Users This Week" articles={top.week.data} loading={top.week.isLoading} ordered />
			<Articles title="My Reading List" subtitle="Your Next Reads, Purchased Articles, & More!" articles={bookmarked.data} loading={bookmarked.isLoading} />
			<Articles title="My Reading History" subtitle="Recently Viewed" articles={lastSeen.data} loading={lastSeen.isLoading} />
		</>
	);
};

Home.Out = () => {
	const featured = useFeatured();
	const featuresTitle = <>What Makes Subly <b>Different</b></>;

	return (
		<>
			<Subscribe {...featured.subscribe} />
			<Faq />
			<Articles center title="Top Articles" subtitle="Most Popular Articles Unlocked By Subly Users This Week" articles={featured.data} loading={featured.isLoading} ordered read={false} />
			<Features title={featuresTitle} features={featured.features} />
		</>
	);
};

export default function Home() {
	const start = useStart();
	const partners = usePartners();
	const loggedIn = Boolean(start.user);

	return (
		<Layout>
			{loggedIn ? <Home.In /> : <Home.Out />}
			<Partners partners={partners.data} />
		</Layout>
	);
}